<!-- svelte-ignore a11y-missing-attribute -->
<div class="modal is-active">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"></p>
      <button class="delete" aria-label="close" on:click={close} />
    </header>

    <section class="modal-card-body is-flex is-flex-direction-rcolumn is-justify-content-center">
      <img src={images[index]} />
    </section>
    <footer class="modal-card-foot is-flex is-flex-direction-column is-justify-content-center">
      <nav
        class="pagination is-small is-rounded"
        role="navigation"
        aria-label="pagination"
      >
        <a class="pagination-previous" on:click={previous}>&lt;</a>
        <ul class="pagination-list">
          {#each images as images,i}
          <li><a on:click={() => {index = i}} class="pagination-link" class:is-current={index === i} aria-label="Goto page">{i+1}</a></li>
          {/each}
        </ul>

        <a class="pagination-next" on:click={next}>&gt;</a>
      </nav>
    </footer>
  </div>
</div>

<script lang="ts">
  export let images : string[], index : number;
  import { uiState } from "../../lib/uiState";

  function previous() {
    if (index > 0) index--;
  }

  function next() {
    if (index < images.length - 1) index++;
  }

  function close() {
    $uiState.activeModal = undefined;
  }
</script>
